import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSidebar, IconDefinition } from '@fortawesome/pro-light-svg-icons';
import React from 'react';

interface Props {
  title?: string;
  onClose?: () => void;
  className?: string;
  icon?: IconDefinition;
  iconPosition?: 'left' | 'right';
}

const SidebarHeader = ({
  title,
  onClose,
  className,
  icon,
  iconPosition,
}: Props) => {
  if (!title) {
    return (
      <div
        className={`w-full flex ${iconPosition === 'right' ? 'justify-end' : 'justify-start'} ${className}`}
      >
        {onClose && (
          <div onClick={onClose} className="p-5 pt-4 cursor-pointer">
            <FontAwesomeIcon icon={icon ?? faSidebar} color="#000" size="lg" />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`w-full flex items-center justify-between ${className}`}>
      {title && <div className="text-lg pl-5">{title}</div>}
      {onClose && (
        <div
          onClick={onClose}
          className="cursor-pointer flex items-center justify-center p-5"
        >
          <FontAwesomeIcon icon={icon ?? faSidebar} color="#000" size="lg" />
        </div>
      )}
    </div>
  );
};

export default SidebarHeader;
